/* istanbul ignore file */
import TextCell from './TextCell';

const ParentCell = ({ parent }) => {
  const isParentExists = !!parent;
  const title = isParentExists ? parent?.title || 'N/A' : '';
  return <TextCell text={title} />;
};

export default ParentCell;
